import { useContext, useEffect } from "react";
import { EntityContext } from "../../../../contexts/EntityContext";
import {
  getLocalStorageData,
  clearLocalStorageData,
} from "../../../../shared/utils/localStorage";
import { Box, Grid, Typography } from "@mui/material";
import { BarChart, LineChart } from "@mui/x-charts";
import CardTiles from "../../../../shared/components/cardTiles";
import SvgIcons from "../../../../shared/components/svgIcons";

const Dashboard = () => {
  const { setEntityName } = useContext(EntityContext);
  useEffect(() => {
    getLocalStorageData("token");
    setEntityName({ entityName: "Dashboard", entityTitle: "Dashboard" });
  }, [setEntityName]);

  useEffect(() => {
    const token = getLocalStorageData("token");
    if (token) {
    } else {
      clearLocalStorageData();
      window.location.href = "/login";
    }
  }, []);

  return (
    <>
      <Box className="dashBoardMain">
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={3}>
            <CardTiles
              number={3}
              title="Services"
              Icon={<SvgIcons.ServicesIcon />}
            />
          </Grid>
          <Grid item xs={3}>
            <CardTiles
              number={100}
              title="Resellers"
              Icon={<SvgIcons.ServiceProvidersIcon />}
            />
          </Grid>
          <Grid item xs={3}>
            <CardTiles
              number={35}
              title="Users"
              Icon={<SvgIcons.TotalUsersIcon />}
            />
          </Grid>
          <Grid item xs={3}>
            <CardTiles
              number={"3 LK"}
              title="Total Revenue"
              Icon={<SvgIcons.RevenueIcon />}
            />
          </Grid>
          <Grid item xs={6}>
            <Box>
              <Box>
                <Typography variant="h4" fontWeight={500}>
                  Resellers Overview
                </Typography>
              </Box>
              {/* SVG Gradients for Each Bar */}
              <svg width="0" height="0">
                <defs>
                  <linearGradient
                    id="yellowGradient1"
                    x1="0"
                    y1="0"
                    x2="0"
                    y2="1"
                  >
                    <stop offset="0%" stopColor="#d6e4e2" /> {/* Gold */}
                    <stop offset="100%" stopColor="#06584a" /> {/* Orange */}
                  </linearGradient>
                  <linearGradient
                    id="yellowGradient2"
                    x1="0"
                    y1="0"
                    x2="0"
                    y2="1"
                  >
                    <stop offset="0%" stopColor="#06584a" /> {/* Yellow */}
                    <stop offset="100%" stopColor="#d6e4e2" /> {/* Gold */}
                  </linearGradient>
                  <linearGradient
                    id="yellowGradient3"
                    x1="0"
                    y1="0"
                    x2="0"
                    y2="1"
                  >
                    <stop offset="0%" stopColor="#d6e4e2" />{" "}
                    {/* LemonChiffon */}
                    <stop offset="100%" stopColor="#06584a" /> {/* Gold */}
                  </linearGradient>
                </defs>
              </svg>

              {/* BarChart with Different Gradients */}
              <BarChart
                xAxis={[
                  {
                    scaleType: "band",
                    data: ["group A", "group B", "group C"],
                  },
                ]}
                series={[
                  { data: [4, 3, 5], color: "url(#yellowGradient1)" }, // 1st bar gradient
                  { data: [1, 6, 3], color: "url(#yellowGradient2)" }, // 2nd bar gradient
                  { data: [2, 5, 6], color: "url(#yellowGradient3)" }, // 3rd bar gradient
                ]}
                height={375}
                barLabel="value"
              />
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box>
              <Box>
                <Typography variant="h4" fontWeight={500}>
                  Monthly Revenue
                </Typography>
              </Box>
              <LineChart
                xAxis={[{ data: [1, 2, 3, 5, 8, 10] }]}
                series={[
                  {
                    data: [2, 5.5, 2, 8.5, 1.5, 5],
                  },
                ]}
                height={400}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Dashboard;
